import { palette, textColor } from '../color-token';
export function getTextStyles(font) {
  const {
    WEIGHT: {
      REGULAR,
      SEMI_BOLD
    },
    FAMILY
  } = font;
  return {
    HEADING_1: {
      COLOR: 'inherit',
      WEIGHT: REGULAR,
      SIZE: '32px',
      MOBILE_SIZE: '24px',
      LINE_HEIGHT: 1.125,
      FAMILY
    },
    HEADING_2: {
      COLOR: 'inherit',
      WEIGHT: REGULAR,
      SIZE: '24px',
      MOBILE_SIZE: '20px',
      LINE_HEIGHT: 1.25,
      FAMILY
    },
    HEADING_3: {
      COLOR: 'inherit',
      WEIGHT: SEMI_BOLD,
      SIZE: '18px',
      MOBILE_SIZE: '16px',
      LINE_HEIGHT: 1.333,
      FAMILY
    },
    HEADING_4: {
      COLOR: 'inherit',
      WEIGHT: SEMI_BOLD,
      SIZE: '16px',
      MOBILE_SIZE: '16px',
      LINE_HEIGHT: 1.5,
      FAMILY
    },
    BODY_1: {
      COLOR: textColor['color-text-default'],
      // NEUTRALS.GREY_COOL_DARK_300,
      WEIGHT: REGULAR,
      SIZE: '16px',
      MOBILE_SIZE: '16px',
      LINE_HEIGHT: 1.5,
      FAMILY
    },
    BODY_2: {
      COLOR: textColor['color-text-default'],
      // NEUTRALS.GREY_COOL_DARK_300,
      WEIGHT: REGULAR,
      SIZE: '15px',
      MOBILE_SIZE: '15px',
      LINE_HEIGHT: 1.6,
      FAMILY
    },
    BUTTON: {
      COLOR: textColor['color-text-default'],
      // NEUTRALS.GREY_COOL_DARK_300,
      WEIGHT: SEMI_BOLD,
      SIZE: '16px',
      MOBILE_SIZE: '16px',
      LINE_HEIGHT: 1.25,
      FAMILY
    },
    TAG: {
      COLOR: textColor['color-text-default'],
      // NEUTRALS.GREY_COOL_DARK_300,
      WEIGHT: REGULAR,
      SIZE: '13px',
      MOBILE_SIZE: '13px',
      LINE_HEIGHT: 20 / 13,
      FAMILY
    },
    SIDE_MENU: {
      COLOR: palette['palette-grey-dark-400'],
      // NEUTRALS.GREY_COOL_DARK_400,
      WEIGHT: REGULAR,
      SIZE: '16px',
      MOBILE_SIZE: '16px',
      LINE_HEIGHT: 1.5,
      FAMILY
    }
  };
}